import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { VEHICLES_TYPES } from 'constants/survey'
import { connect } from 'react-redux';
import { resetFrom, nextStep, updateSurvey } from 'store/actions';
import Analytics from '../../utils/analytics';

import SelectionCard from 'components/SelectionCard/SelectionCard';
import StepperNav from 'components/StepperNav/StepperNav';

import truckImg from 'assets/images/vehicles/red-truck-cut.png';
import carImg from 'assets/images/vehicles/car-cut.png';
import vanImg from 'assets/images/vehicles/van-cut.png';
import taxiImg from 'assets/images/vehicles/taxi-cut.png';
import mixImg from 'assets/images/vehicles/mix-cut.png';
import otherImg from 'assets/images/vehicles/other-cut.png';

const mapStateToProps = (state) => ({
  survey: state.survey
});

const mapDispatchToProps = (dispatch) => ({
  resetFrom: (prop) => dispatch(resetFrom(prop)),
  nextStep: () => dispatch(nextStep()),
  updateSurvey: (survey) => dispatch(updateSurvey(survey))
});

class Step1 extends Component {
  constructor(props, context) {
    super(props);
  }

  handleSelection = (selectedVehicleType) => {
    const { survey, resetFrom, updateSurvey, nextStep } = this.props;
    if (!survey.vehicleType.length || survey.vehicleType === selectedVehicleType) {
      // Update data from the last step
      const updatedSurvey = {
        ...survey,
        ...{vehicleType: selectedVehicleType},
      };

      updateSurvey(updatedSurvey);
    } else {
      resetFrom({vehicleType: selectedVehicleType});
    }

    const filteredType = Analytics.removeAccentMarkAndUppercase(selectedVehicleType);

    Analytics.pushData({
      eventCategory: 'recomendador starressa',
      eventAction: 'clic tarjetas',
      eventLabel: `step1_tipo vehiculo_${filteredType}`
    });

    nextStep();
  }

  render() {
    const { t, survey } = this.props;

    const vehiclesTypes = [
      {
        name: t(VEHICLES_TYPES.TRUCK),
        imgSrc: truckImg
      },
      {
        name: t(VEHICLES_TYPES.CAR),
        imgSrc: carImg
      },
      {
        name: t(VEHICLES_TYPES.VAN),
        imgSrc: vanImg
      },
      {
        name: t(VEHICLES_TYPES.TAXI),
        imgSrc: taxiImg
      },
      {
        name: t(VEHICLES_TYPES.MIX),
        imgSrc: mixImg
      },
      {
        name: t(VEHICLES_TYPES.OTHER),
        imgSrc: otherImg
      }
    ]

    return (
      <section className="m-step">
        <div className="m-step__header">
          <h2 className="t-h2 m-step__title">{t('steps.step1.title')}</h2>
        </div>
        <div className="m-step m-step__content">
          <div className="m-step__cards-wrapper">
            {
              vehiclesTypes.map((type, index) => {
                return (
                  <SelectionCard
                    extraClass={"m-step__card m-step__card--third m-step__card--vehicle" + (survey.vehicleType.length && vehiclesTypes[index].name === survey.vehicleType ? ' is-active' : '')}
                    key={index}
                    onClick={() => this.handleSelection(vehiclesTypes[index].name)}
                    label={vehiclesTypes[index].name}
                    imgSrc={vehiclesTypes[index].imgSrc} />
                );
              })
            }
          </div>
        </div>
        <StepperNav hideNextBtn={true} />
      </section>
    );
  }
}

const ConnectedStep1 = connect(mapStateToProps, mapDispatchToProps)(Step1);

export default withTranslation('translations')(ConnectedStep1);
